var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"actions-header__item header-favorite",class:{'_active': _vm.hasFavorites},attrs:{"href":this.$root.baseUrl + '/favorites'}},[_c('span',[_vm._v(_vm._s(_vm.totalFavorites || ''))])])
}
var staticRenderFns = []

export { render, staticRenderFns }